import { render } from "./SearchAlgolia.vue?vue&type=template&id=d9601d06"
import script from "./SearchAlgolia.vue?vue&type=script&lang=js"
export * from "./SearchAlgolia.vue?vue&type=script&lang=js"

import "./SearchAlgolia.vue?vue&type=style&index=0&id=d9601d06&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__